<template>
<div class="tabs">
  <ul class="tabs-header">
    <li v-for="(tab, ti) in tabs" v-on:click.prevent="activeTab=ti">
      {{ activeTab==ti?"*":"" }} {{ tab.name }}
    </li>
  </ul>
  <slot />
</div>
</template>

<script>
export default {
  data: ()=>({
    tabs: [],
    activeTab: 0,
  }),
  methods: {
    tabsRegisterInner(el) {
      if (this.tabs.indexOf(el)==-1)
        this.tabs.push(el);
    },
    tabsUnregisterInner(el) {
      if (this.tabs.indexOf(el)!=-1)
        this.tabs.splice(this.tabs.indexOf(el), 1);
    },
  },
}
</script>
